import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import feedEN from "../features/Feeds/i18n/en.json";
import feedAR from "../features/Feeds/i18n/ar.json";

import profilesEN from "../features/Profiles/i18n/en.json";
import profilesAR from "../features/Profiles/i18n/ar.json";

import translationAR from "./Arabic.json";
import translationEN from "./English.json";

import commonAR from "./commonAR.json";
import commonEN from "./commonEN.json";

import userEN from "../features/User/i18n/en.json";
import userAR from "../features/User/i18n/ar.json";

import groupsEN from "../features/Groups/i18n/en.json";
import groupsAR from "../features/Groups/i18n/ar.json";

import entityEN from "../features/Entity/i18n/en.json";
import entityAR from "../features/Entity/i18n/ar.json";
import adsEN from "../features/Ads/i18n/en.json";
import adsAR from "../features/Ads/i18n/ar.json";

import goServiceEN from "../features/GoService/i18n/en.json";
import goServiceAR from "../features/GoService/i18n/ar.json";

import chatEN from "../features/Chat/i18n/en.json";
import chatAR from "../features/Chat/i18n/ar.json";

import ginoEN from "../features/GINO/i18n/en.json";
import ginoAR from "../features/GINO/i18n/ar.json";

import goHireEN from "../features/GoHire/i18n/en.json";
import goHireAR from "../features/GoHire/i18n/ar.json";

import plansEN from "../features/Plans/i18n/en.json";
import plansAR from "../features/Plans/i18n/ar.json";

import networkingEN from "../features/Networking/i18n/en.json";
import networkingAR from "../features/Networking/i18n/ar.json";

import layoutEN from "../features/ApplicationLayout/i18n/en.json";
import layoutAR from "../features/ApplicationLayout/i18n/ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEN,
      feed: feedEN,
      common: commonEN,
      profiles: profilesEN,
      user: userEN,
      groups: groupsEN,
      entity: entityEN,
      ads: adsEN,
      goService: goServiceEN,
      chat: chatEN,
      gino: ginoEN,
      goHire: goHireEN,
      plans: plansEN,
      networking: networkingEN,
      layout: layoutEN,
    },
    ar: {
      translation: translationAR,
      feed: feedAR,
      common: commonAR,
      profiles: profilesAR,
      user: userAR,
      groups: groupsAR,
      entity: entityAR,
      ads: adsAR,
      goService: goServiceAR,
      chat: chatAR,
      gino: ginoAR,
      goHire: goHireAR,
      plans: plansAR,
      networking: networkingAR,
      layout: layoutAR,
    },
  },
  lng: "en",
  fallbackLng: "en",

  ns: [
    "translation",
    "feed",
    "common",
    "profiles",
    "user",
    "entity",
    "ads",
    "goService",
    "chat",
    "goHire",
    "plans",
    "networking",
    "layout",
  ], // list all namespaces
  defaultNS: "translation",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
